module.exports = __webpack_public_path__ + "static/media/MHRM09N0004.e127096f.svg";